/**
 * Group label above each Settings card ("Account", "Household", …).
 *
 * `text-text-heading` (#1a1a1a), not `text-foreground` (#2f2f2f): Figma
 * gives section headings the darker heading tone, and QA reported all five
 * of them as "#2f2f2f, should be #1a1a1a" on YAR-230.
 */
export function SectionHeading({ children }: { children: React.ReactNode }) {
  return (
    <h3 className="text-base font-medium text-text-heading mb-2">{children}</h3>
  );
}
